import { StaticImage } from "gatsby-plugin-image";
import React from "react";
import ContentContainer from "../../../components/container/ContentContainer";
import ContentContainerNew from "../../../components/container/ContentContainerNew";
import ContactExpert from "../../../components/controls/ContactExpert";
import Header from "../../../components/sections/Header";
import HeadData from "../../../data/HeadData";
import { useStaticQuery, graphql } from "gatsby";
import TitleSubDiv from "../../../components/controls/TitleSubDiv";
import ButtonAction from "../../../components/controls/ButtonAction";
import Thumbnail from "../../../components/controls/Thumbnail";
import SimpleReactLightbox from "simple-react-lightbox";
import Layout from "../../../components/layout/Layout";

const ThermallyFusedLaminate = () => {
  const images = useStaticQuery(graphql`
    {
      backGround: file(relativePath: { eq: "arauco-prism-bg.jpg" }) {
        childImageSharp {
          gatsbyImageData(
            placeholder: BLURRED
            formats: [AUTO, WEBP]
            quality: 100
          )
        }
      }
      tactilThumb: allFile(
        filter: { relativeDirectory: { eq: "thermally-fused-laminates/tactil" } }
        sort: { order: ASC, fields: name }
      ) {
        edges {
          node {
            name
            id
            relativePath
            childImageSharp {
              gatsbyImageData(
                placeholder: BLURRED
                layout: CONSTRAINED
                quality: 100
                formats: [AUTO, WEBP]
              )
            }
          }
        }
      }
      abstractsThumb: allFile(
        filter: { relativeDirectory: { eq: "thermally-fused-laminates/abstracts" } }
        sort: { order: ASC, fields: name }
      ) {
        edges {
          node {
            name
            id
            relativePath
            childImageSharp {
              gatsbyImageData(
                placeholder: BLURRED
                layout: CONSTRAINED
                quality: 100
                formats: [AUTO, WEBP]
              )
            }
          }
        }
      }
      solidsThumb: allFile(
        filter: { relativeDirectory: { eq: "thermally-fused-laminates/solids" } }
        sort: { order: ASC, fields: name }
      ) {
        edges {
          node {
            name
            id
            relativePath
            childImageSharp {
              gatsbyImageData(
                placeholder: BLURRED
                layout: CONSTRAINED
                quality: 100
                formats: [AUTO, WEBP]
              )
            }
          }
        }
      }
      woodGrainsThumb: allFile(
        filter: { relativeDirectory: { eq: "thermally-fused-laminates/wood-grains" } }
        sort: { order: ASC, fields: name }
      ) {
        edges {
          node {
            name
            id
            relativePath
            childImageSharp {
              gatsbyImageData(
                placeholder: BLURRED
                layout: CONSTRAINED
                quality: 100
                formats: [AUTO, WEBP]
              )
            }
          }
        }
      }
    }
  `);

  const path = ["Arauco Prism Thermally Fused Laminate (Melamine) Panels"];
  return (
    <Layout>
      <div className="w-full max-w-full relative overflow-hidden">
        <HeadData 
          title="Arauco Prism® Thermally Fused Laminate (Melamine) Panels - So Cal"
          description="Arauco Prism® is a brand of thermally fused laminate (TFL) (melamine) panels by ARAUCO, offering a wide range of durable, sustainable, and on-trend decorative surfaces for residential and commercial interior design, cabinetry, and furniture."
          noIndex
        />
        <Header />
        <TitleSubDiv
          parentText="Products"
          title="Arauco Prism® Thermally Fused Laminate (Melamine) Panels in Southern California"
          className="mb-8"
          path={path}
        />
        <ContentContainer
          className="w-full max-w-content md:mx-5 flex items-center justify-center"
          opacityClassName="bg-opacity-30"
          image={images.backGround}
        >
          <div className="flex flex-col items-center justify-center my-20 gap-y-4 w-full max-w-3xl">
            <h1 className="text-3xl md:text-4xl text-white text-center font-bold">Arauco Prism<sup>&reg;</sup> Thermally Fused Laminate (Melamine) Panels</h1>
            <p className="text-base mt-5 text-center text-white">
              Arauco began in 1970 in Santiago, Chile, and has been a global manufacturer of forest products, serving North America with excellence in manufacturing and distribution of wood products for over half a century.
            </p>
            <ButtonAction to="/contact" className="mt-10 bg-actionBlue text-white px-16">
              Request Free Quote
            </ButtonAction>
          </div>
        </ContentContainer>

        <ContentContainerNew
          containerClassName="w-full mt-10 md:mt-24"
          className="flex flex-col px-0 md:px-4 w-full max-w-7xl"
        >
          <div className="flex flex-col sm:flex-row">
            <div className="w-full sm:w-7/12 p-5 sm:pl-0 sm:pr-8">
              <p className="mb-6">
                Arauco Prism<sup>&reg;</sup> is a brand of thermally fused laminate (TFL) (melamine) panels by ARAUCO, offering a wide range of durable, sustainable, and on-trend decorative surfaces for residential and commercial interior design, cabinetry, and furniture.
              </p>
              <p className="mb-6">The product line features realistic woodgrain, abstract, and solid color designs with various textures, alongside complementary products like edgebanding and HPL.</p>
              <p className="mb-6">Prism TFL is a cost-effective, value-engineered alternative to wood veneer, made with limate-positive wood cores, and designed to meet green building standards.</p>
              <p className="text-sm"><span className="font-bold uppercase">Photo</span>: Aetna Plywood</p>
            </div>
            <div className="w-full sm:w-5/12">
              <StaticImage
                src="../../../images/thermally-fused-laminates/arauco-page-section.jpg"
                alt="Arauco Prism TFL"
                placeholder="blurred"
                quality={100}
                layout="constrained"
              />
            </div>
          </div>
        </ContentContainerNew>

        <ContentContainer className="bg-gray5 text-center py-12 mt-14">
          <h2>Collection</h2>
        </ContentContainer>
        <ContentContainer className="bg-gray2 py-2 mb-9">
          <div className="flex flex-col text-center items-center px-5 md:px-20 py-20">
            <p className="text-3xl font-raleway font-bold">Tactil</p>
            <hr className="border-blue4 border-t-2 mt-4 mb-3 w-56" />
            <p>Super matte finish with anti-fingerprint technology, scratch, wear and impact resistant.</p>
            <SimpleReactLightbox>
              <div className="grid grid-cols-3 lg:grid-cols-4 xl:grid-cols-5 w-full mt-20 gap-5 md:gap-x-14 md:gap-y-11 items-start">
                {images.tactilThumb.edges.map((thumbnail, index) => {
                  return (
                    <Thumbnail
                      key={`gallery${index}`}
                      hiRes={
                        thumbnail.node.childImageSharp.gatsbyImageData.images
                          .fallback.src
                      }
                      name={thumbnail.node.name}
                      thumbnail={thumbnail.node.childImageSharp.gatsbyImageData}
                      thumbnailClassName="max-h-26 min-h-26 md:max-h-52 md:min-h-52 opacity-100"
                    />
                  );
                })}
              </div>
            </SimpleReactLightbox>
          </div>
        </ContentContainer>

        <ContentContainer className="bg-gray5 text-center py-12">
          <h2>Collection</h2>
        </ContentContainer>
        <ContentContainer className="bg-gray2 py-2 mb-9">
          <div className="flex flex-col text-center items-center px-5 md:px-20 py-20">
            <p className="text-3xl font-raleway font-bold">
              Abstracts
            </p>
            <SimpleReactLightbox>
              <div className="grid grid-cols-3 lg:grid-cols-4 xl:grid-cols-5 w-full mt-20 gap-5 md:gap-x-14 md:gap-y-11 items-start">
                {images.abstractsThumb.edges.map((thumbnail, index) => {
                  return (
                    <Thumbnail
                      key={`gallery${index}`}
                      hiRes={
                        thumbnail.node.childImageSharp.gatsbyImageData.images
                          .fallback.src
                      }
                      name={thumbnail.node.name}
                      thumbnail={thumbnail.node.childImageSharp.gatsbyImageData}
                      thumbnailClassName="max-h-26 min-h-26 md:max-h-52 md:min-h-52 opacity-100"
                    />
                  );
                })}
              </div>
            </SimpleReactLightbox>
          </div>
        </ContentContainer>

        <ContentContainer className="bg-gray5 text-center py-12">
          <h2>Collection</h2>
        </ContentContainer>
        <ContentContainer className="bg-gray2 py-2 mb-9">
          <div className="flex flex-col text-center items-center px-5 md:px-20 py-20">
            <p className="text-3xl font-raleway font-bold">
              Solids
            </p>
            <SimpleReactLightbox>
              <div className="grid grid-cols-3 lg:grid-cols-4 xl:grid-cols-5 w-full mt-20 gap-5 md:gap-x-14 md:gap-y-11 items-start">
                {images.solidsThumb.edges.map((thumbnail, index) => {
                  return (
                    <Thumbnail
                      key={`gallery${index}`}
                      hiRes={
                        thumbnail.node.childImageSharp.gatsbyImageData.images
                          .fallback.src
                      }
                      name={thumbnail.node.name}
                      thumbnail={thumbnail.node.childImageSharp.gatsbyImageData}
                      thumbnailClassName="max-h-26 min-h-26 md:max-h-52 md:min-h-52 opacity-100"
                    />
                  );
                })}
              </div>
            </SimpleReactLightbox>
          </div>
        </ContentContainer>

        <ContentContainer className="bg-gray5 text-center py-12">
          <h2>Collection</h2>
        </ContentContainer>
        <ContentContainer className="bg-gray2 py-2">
          <div className="flex flex-col text-center items-center px-5 md:px-20 py-20">
            <p className="text-3xl font-raleway font-bold">
              Wood Grains
            </p>
            <SimpleReactLightbox>
              <div className="grid grid-cols-3 lg:grid-cols-4 xl:grid-cols-5 w-full mt-20 gap-5 md:gap-x-14 md:gap-y-11 items-start">
                {images.woodGrainsThumb.edges.map((thumbnail, index) => {
                  return (
                    <Thumbnail
                      key={`gallery${index}`}
                      hiRes={
                        thumbnail.node.childImageSharp.gatsbyImageData.images
                          .fallback.src
                      }
                      name={thumbnail.node.name}
                      thumbnail={thumbnail.node.childImageSharp.gatsbyImageData}
                      thumbnailClassName="max-h-26 min-h-26 md:max-h-52 md:min-h-52 opacity-100"
                    />
                  );
                })}
              </div>
            </SimpleReactLightbox>
          </div>
        </ContentContainer>

        <ContentContainer className="w-full max-w-content mt-8">
          <div>
            <p className="text-center text-lg md:text-xl uppercase mt-8 mb-6">For More Information:</p> 
          </div>
          <div className="w-auto mx-auto flex flex-col items-center justify-center">
            <a href="https://nwpsocal.cdn.prismic.io/nwpsocal/aVOSqnNYClf9osAD_PrismTFL_surface_performance_properties_vAUG2025_.pdf" target="_blank" rel="noopener noreferrer">
              <button className="bg-actionBlue text-white px-8 py-3 text-lg rounded-full text-center">
                TFL Performance Standards
              </button>
            </a>

            <a href="https://nwpsocal.cdn.prismic.io/nwpsocal/aVOSqHNYClf9osAC_PrismTFL_care_for_tfl_panels_r0629.pdf" target="_blank" rel="noopener noreferrer">
              <button className="bg-actionBlue text-white px-8 py-3 text-lg rounded-full text-center mt-8">
               TFL Maintenance and Cleaning
              </button>
            </a>
          </div>
        </ContentContainer>

        <ContentContainer className="w-full max-w-content mt-16 mb-6">
          <div className="bg-gray2 text-center flex flex-col gap-y-10 py-10 sm:py-24 px-5 xl:px-102 text-lg md:text-xl">
            <i>
              “ARAUCO Prism<sup>&reg;</sup> TFL is the most responsible surfacing solution available. Our extensive collection of on-trend styles and textures look authentic and are appealing to the touch. In addition, Prism TFL is a durable and sustainable surface that can replace wood veneer, is manufactured with climate-positive composite wood cores and can contribute to LEED points, making it a truly cradle to gate product.”
            </i>
            <p>- Arauco Prism<sup>&reg;</sup></p>
          </div>
        </ContentContainer>

        <ContactExpert />
      </div>
    </Layout>
  );
};

export default ThermallyFusedLaminate;
